import React from "react";
import { PdfCanvasViewer } from "./PdfCanvasViewer";

export const PdfPreviewModal = ({ title, filename, blob, url, onClose }) => {
  const print = () => {
    const f = document.createElement("iframe");
    f.style.display = "none";
    f.src = url;
    f.onload = () => { try { f.contentWindow.print(); } catch { window.open(url, "_blank"); } };
    document.body.appendChild(f);
  };
  return (
    <div className="fixed inset-0 z-50 bg-black/60 flex items-center justify-center p-4" data-testid="pdf-preview-modal" onClick={onClose}>
      <div className="bg-white rounded-2xl shadow-xl w-full max-w-4xl flex flex-col" style={{ height: "90vh" }} onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center justify-between px-4 py-2 border-b border-[#E4E4E7]">
          <div className="font-bold text-sm">{title}</div>
          <div className="flex items-center gap-2">
            <button onClick={print} className="btn-secondary text-xs" data-testid="pdf-preview-print">Print</button>
            <a href={url} download={filename} className="btn-secondary text-xs" data-testid="pdf-preview-download">Download</a>
            <button data-testid="pdf-preview-close" className="btn-ghost" onClick={onClose} title="Close">✕</button>
          </div>
        </div>
        <PdfCanvasViewer blob={blob} url={url} />
      </div>
    </div>
  );
};
